import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, } from "react-router-dom";
import { getFormDate, getOnsearch, getStatus, getToDate, getUserId } from "../../redux/actions/adminAction";

const Header = () => {
    const LocationURL = useLocation().pathname
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getOnsearch(""))
        dispatch(getStatus(""))
        dispatch(getUserId(""))
        dispatch(getFormDate(""))
        dispatch(getToDate(""))
    }, [LocationURL, dispatch])

    return (
        <>
            <div className="row">
                <div className="col-12 ">
                    <div className="row ">
                    </div>
                </div>
            </div>
        </>
    )
}


export default Header